var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingSessionButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51302 18.3307H12.513C16.6797 18.3307 18.3464 16.6641 18.3464 12.4974V7.4974C18.3464 3.33073 16.6797 1.66406 12.513 1.66406H7.51302C3.34635 1.66406 1.67969 3.33073 1.67969 7.4974V12.4974C1.67969 16.6641 3.34635 18.3307 7.51302 18.3307Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96289 12.939L11.8962 9.99733L8.96289 7.05566",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingSessionButtonIcon);
export default __webpack_public_path__ + "static/media/onboardingSessionButtonIcon.f9bdcf73bb4565933b3b02fca5c8229e.svg";
export { ForwardRef as ReactComponent };